export default __webpack_public_path__ + "static/media/thumb-IVTS-5.0ba88d07.png";